import { Button } from "@mui/material";
import VpnKeyIcon from "@mui/icons-material/VpnKey";

interface ShareCredentialsChatButtonProps {
  missingCredentials: boolean;
  isLoading: boolean;
  handleShareCredentials: () => void;
  visible: boolean;
}

export function ShareCredentialsChatButton(props: ShareCredentialsChatButtonProps) {
  const { missingCredentials, handleShareCredentials, visible, isLoading } = props;

  if (!visible || isLoading) {
    return null;
  }

  return (
    <Button
      onClick={handleShareCredentials}
      variant={missingCredentials ? "contained" : "outlined"}
      startIcon={<VpnKeyIcon />}
      sx={{
        ...(!missingCredentials && { border: (theme) => `1px solid ${theme.palette.divider}` }),
      }}
    >
      {missingCredentials ? "Share Credentials" : "Edit Credentials"}
    </Button>
  );
}
